export default {
  // Please list all keys for all items stored in local storage here.  eg. 'test' stores the test variable.
  LocalStorageItems: {
    test: 'test',
    sidebarOpenAppAnalytics: 'sidebar.open.app-analytics',
    sidebarOpenAssetsListing: 'sidebar.open.assets-listing',
    assetListingSearchForm: 'asset-listing.search-form',
    streamingAnalyticsSlideOutDrawerWidth: 'streaming-analytics.sa-slide-out-drawer-width',
    streamingAnalyticsGeoCardLayerPrefs: 'streaming-analytics.sa-geo-card-layer-prefs',
    liveBroadcastsManualOrder: 'live-broadcast.manual-order',
    VNMessages: 'vn-messages',
  },

  /**
   * Get getItem
   *
   * @returns {Promise<any>}
   */
  getItem(name: string): any {
    let value;
    if (window.localStorage) {
      value = window.localStorage.getItem(name);
    }
    if (!value) return null;
    return JSON.parse(value);
  },

  setItem(name: string, value: any): any {
    const stringValue = JSON.stringify(value);
    if (window.localStorage) {
      window.localStorage.setItem(name, stringValue);
    }
    return value;
  },
  removeItem(name: string): any {
    if (window.localStorage) {
      window.localStorage.removeItem(name);
    }
  },
  clear() {
    if (window.localStorage) {
      window.localStorage.clear();
    }
  },
};
